import { render, staticRenderFns } from "./CreateSalesOrderDialog.vue?vue&type=template&id=34b13432"
import script from "./CreateSalesOrderDialog.vue?vue&type=script&lang=js"
export * from "./CreateSalesOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports